import { AppId, FCX, ProductLogo, usePlatformContext, usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import { MAC_NEW_ORIGIN_FLAG } from "@apiHooks/useMacs.constants";
import MacNew from "../MacNew";
import MacObsolete from "../MacObsolete";
import "@pages/Documents/MacDetails/MacDetails.scss";

const MacSwitch: FCX = () => {
    const { isUserInfoLoaded } = usePlatformContext();
    const isNewOriginEnabled = usePlatformFeatureFlag(MAC_NEW_ORIGIN_FLAG);

    if (!isUserInfoLoaded) {
        return (
            <div className="MacDetails__spinner" data-testid="blockMacDetailsSwitchLoading">
                <ProductLogo appId={AppId.Snap} type="regular"/>
            </div>
        );
    }

    return isNewOriginEnabled ? <MacNew/> : <MacObsolete/>;
};

export default MacSwitch;
